import { render, staticRenderFns } from "./ItemLanguage.vue?vue&type=template&id=a0cd3a92&scoped=true"
import script from "./ItemLanguage.vue?vue&type=script&lang=js"
export * from "./ItemLanguage.vue?vue&type=script&lang=js"
import style0 from "./ItemLanguage.vue?vue&type=style&index=0&id=a0cd3a92&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cd3a92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0cd3a92')) {
      api.createRecord('a0cd3a92', component.options)
    } else {
      api.reload('a0cd3a92', component.options)
    }
    module.hot.accept("./ItemLanguage.vue?vue&type=template&id=a0cd3a92&scoped=true", function () {
      api.rerender('a0cd3a92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/ItemLanguage.vue"
export default component.exports